import LoginForm from "../pages/employeeNew/employeeLogin";
import ForgotForm from "../pages/employeeNew/employeeForgotPassword.vue";

// Employee Dashboard
import UpdatePassword from "../pages/employeeNew/updatePassword.vue";
import EmployeeDashboard from "../pages/employeeNew/employeeDashboard.vue";
import EmployeeProfileNewLayout from "../pages/employeeNew/employeeProfileNewLayout.vue"
import EmployeeApprovalList from "../pages/employeeNew/employeeApproveList.vue";
import ManagerDashboard from "../pages/employeeNew/managerDashboard.vue";
import ComplaintsDashboard from "../pages/employeeNew/complaintsDashboard.vue";
import ViewComplaints from "../pages/employeeNew/viewComplaints.vue";
import GiftsApproval from "../pages/employeeNew/giftsApproval.vue";
import EmployeeMisPage from "../pages/employeeNew/employeeMisPage.vue";
import OnboardingPage from "../pages/employeeNew/onboardingPage.vue";

import { requireRole } from "./routeGuards";

import RsOnboardingPage from "../pages/employeeNew/rsOnboardingPage.vue";
import RsForm from "../pages/employeeNew/rsForm.vue";
import FormConfigurationContainer from "../containers/FormConfigurationContainer";
import FormIntroContainer from "../containers/FormIntroContainer";
import FormDetailsContainer from "../containers/FormDetailsContainer";
import FormBuilderContainer from "../containers/FormBuilderContainer";
import FormCssContainer from "../containers/FormCssContainer";
import FormJsonContainer from "../containers/FormJsonContainer";
import FormJsContainer from "../containers/FormJsContainer";
import FormSettingsContainer from "../containers/FormSettingsContainer.vue";

import TasksPage from "../pages/employeeNew/tasksPage.vue";
import UserFormPage from "../pages/employeeNew/user-form.vue";
import EmployeeUserFormPage from "../pages/employeeNew/employeeUserForm.vue";
import EmployeeUserApprovalPage from "../pages/employeeNew/employeeUserApproval.vue";
import EmployeeUserExamPage from "../pages/employeeNew/employeeUserExam.vue";
import EmployeeUserTrainingPage from "../pages/employeeNew/employeeUserTraining.vue";
import EmployeeUserTrainingPDF from "../pages/employeeNew/employeeUserTrainingPDF.vue";
import EmployeeUserTrainingWithPracticeExamPage from "../pages/employeeNew/user-test-training.vue";
import EmployeeComplaintFormPage from "../pages/employeeNew/employeeComplaintForm.vue";
import UpdateEmployeeProfile from "../pages/employeeNew/updateEmployeeProfile.vue";

import employeeTasks from "../pages/employeeNew/employeeTasks.vue"
import employeePolicies from "../pages/employeeNew/employeePolicies.vue"
import employeeTrainings from "../pages/employeeNew/employeeTrainings.vue"
import employeeCertifications from "../pages/employeeNew/employeeCertifications.vue"

import ManageEmployee from "../pages/employeeNew/manageEmployee/manageEmployee.vue";
import AddEmployeeForm from '../pages/employeeNew/manageEmployee/addEmployeeForm.vue';

import employeeApprovals from "../pages/employeeNew/approvalPage/approvalsTable.vue"
import EmployeeApprovalsForm from "../pages/employeeNew/user-form.vue"
import employeeComplaints from "../pages/employeeNew/complaintPage/myComplaintsTable.vue"

// Employee Onboarding Settings
import Departments from "../pages/employeeNew/employeeSettings/departments.vue";
import PlatformsSettings from "../pages/employeeNew/employeeSettings/platformsSetting.vue";
import EmailTags from "../pages/employeeNew/employeeSettings/emailTags.vue";
import WorkFlows from "../pages/employeeNew/employeeSettings/workFlows.vue";
import WorkFlowsIt from "../pages/employeeNew/employeeSettings/workFlowsIt.vue";
import GenralSettingsApproval from "../pages/employeeNew/employeeSettings/genralSettingsApproval.vue";
import CustomFields from "../pages/employeeNew/employeeSettings/customFields.vue";
import Styling from "../pages/employeeNew/employeeSettings/styling.vue";
import AccessControl from "../pages/employeeNew/employeeSettings/accessControl.vue";
import ComplaintTypes from "../pages/employeeNew/employeeSettings/complaintTypes.vue";
// import OptionOne from "../pages/employeeNew/governance/optionOne.vue";
import OptionTwo from "../pages/employeeNew/governance/optionTwo.vue";
import GovernanceDashboard from "../pages/employeeNew/governance/governanceDashboard.vue"
import GoveranceAbc from "../pages/employeeNew/governance/abc.vue";
import TrainingExams from "../pages/employeeNew/training/training.vue";
import HeathAndSafety from "../pages/employeeNew/governance/heathAndSafety.vue"
import UserPrefrences from "../pages/employeeNew/employeeSettings/userPrefrences.vue";

// saml login
import SamlLoginPage from "../pages/employeeNew/samlLoginPage.vue"

// magic-link create password (EB2-58207)
import CreatePassword from "../pages/employeeNew/createPassword.vue"

// magic-link reset password
import ResetPassword from "../pages/employeeNew/resetPassword.vue"


import searchComponent from "../components/ferovial/form.vue"
import store from "../store";

// this showSidebar used to show and hide sidebar as per user type we are storing showSidebar key in localStorage at time of login as per user type
let sidbar = localStorage.getItem( "showSidebar" );
store.state.showSidebar = false;
store.state.showSidebar = sidbar == null ? true : sidbar == '1' ? true : false;
export default [
  {
    path: "/searchform",
    name: "searchComponent",
    component: searchComponent,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/",
    name: "login",
    component: LoginForm,
    meta: { jwtRequiresAuth: false },
  },
  {
    path: "/saml-login",
    name: "login",
    component: SamlLoginPage,
    meta: { jwtRequiresAuth: false },
  },
  {
    path: "/forgot",
    name: "forgot-password",
    component: ForgotForm,
    meta: { jwtRequiresAuth: false },
  },
  {
    path: "/create-password/:token",
    name: "create-password",
    component: CreatePassword,
    meta: { jwtRequiresAuth: false },
  },
  {
    path: "/reset-password/:token",
    name: "reset-password",
    component: ResetPassword,
    meta: { jwtRequiresAuth: false },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: EmployeeDashboard, //ManagerDashboard
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/update-password",
    name: "UpdatePassword",
    component: UpdatePassword,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/manage-employee",
    name: "ManageEmployee",
    component: ManageEmployee,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/add-employee-form",
    name: "AddEmployee",
    component: AddEmployeeForm,
    meta: {
      jwtRequiresAuth: true,
      allowedUserTypes: [1,2]
    },
    beforeEnter: requireRole( [1,2] )
  },
  {

    path: '/user-form',
    name: 'userform',
    props: true,
    component: UserFormPage,
    meta: {
      jwtRequiresAuth: true,
        // denyUserGroupId: 16
    },
    beforeEnter: (to, from, next) => {
        /*let activeTaskStatus = localStorage.getItem("activeTaskStatus");
        if (activeTaskStatus) {
            next()
        } else {
            next('/dashboard');
        }*/
    }
},
  // {
  //   path: "/employee-profile/:id",
  //   name: "EmployeeProfile",
  //   component: EmployeeProfile,
  //   meta: { jwtRequiresAuth: true },
  // },
  // EmployeeProfileNewLayout
  {
    path: "/employee-profile/:id",
    name: "EmployeeProfileNewLayout",
    component: EmployeeProfileNewLayout,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-approval-list",
    name: "EmployeeApprovalList",
    component: EmployeeApprovalList,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/manager-dashboard",
    name: "ManagerDashboard",
    component: ManagerDashboard,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/complaints-dashboard",
    name: "ComplaintsDashboard",
    component: ComplaintsDashboard,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/view-complaint-detail/:complaintId",
    name: "ViewComplaints",
    component: ViewComplaints,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/gifts-approval/:approvalId/:userType",
    name: "userform",
    component: GiftsApproval,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/mis-graph",
    name: "EmployeeMisPage",
    component: EmployeeMisPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/goverance/one",
    name: "GovernanceDashboard",
    component: GovernanceDashboard,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/goverance/health_and_safety",
    name: "HeathAndSafety",
    component: HeathAndSafety,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/goverance/two",
    name: "OptionTwo",
    component: OptionTwo,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/goverance/abc",
    name: "GovernanceAbc",
    component: GoveranceAbc,
    meta: { jwtRequiresAuth: true },
  },

  {
    path: "/training-exams",
    name: "TrainingExams",
    component: TrainingExams,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/tasks",
    name: "TasksPage",
    component: TasksPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/departments",
    name: "Departments",
    component: Departments,
    meta: {
      jwtRequiresAuth: true,
      allowedUserTypes: [1,2]
    },
    beforeEnter: requireRole( [1,2] )
  },
  {
    name: "ComplaintTypes",
    path: "/complaint-types",
    component: ComplaintTypes,
    meta: { jwtRequiresAuth: true },
  },
  {
    name: "WorkFlows",
    path: "/workflows-hr",
    component: WorkFlows,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/onboarding",
    name: "OnboardingPage",
    component: OnboardingPage,
    meta: { jwtRequiresAuth: true },
    meta: {
      jwtRequiresAuth: true,
      allowedUserTypes: [1,2]
    },
    beforeEnter: requireRole( [1,2] )
  },
  {
    path: "/employee-onboarding",
    name: "RsOnboardingPage",
    component: RsOnboardingPage,
    meta: {
      jwtRequiresAuth: true,
      allowedUserTypes: [1,2,3]
    },
    beforeEnter: requireRole( [1,2,3] )
  },
  {
    path: '/form',
    name: 'form',
    component: RsForm,
    props: true,
    meta: {
      jwtRequiresAuth: true,
      allowedUserTypes: [1,2]
    },
    beforeEnter: requireRole( [1,2] ),
    children: [
        {
            path: 'configuration',
            name: 'config',
            props: true,
            component: FormConfigurationContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'intro',
            name: 'intro',
            props: true,
            component: FormIntroContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'details',
            name: 'details',
            props: true,
            component: FormDetailsContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'builder',
            name: 'builder',
            props: true,
            component: FormBuilderContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'css',
            name: 'css',
            props: true,
            component: FormCssContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'json',
            name: 'json',
            props: true,
            component: FormJsonContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'js',
            name: 'js',
            props: true,
            component: FormJsContainer,
            meta: { jwtRequiresAuth: true }
        },
        {
            path: 'settings',
            name: 'settings',
            props: true,
            component: FormSettingsContainer,
            meta: { jwtRequiresAuth: true }
        }
    ]
},
  {
    path: "/platform-settings",
    name: "PlatformsSettings",
    component: PlatformsSettings,
    meta: { jwtRequiresAuth: true },
    meta: {
      jwtRequiresAuth: true,
      allowedUserTypes: [1,2]
    },
    beforeEnter: requireRole( [1,2] )
  },
  {
    path: "/user-prefrences",
    name: "UserPrefrences",
    component: UserPrefrences,
    meta: {
      jwtRequiresAuth: true,
      allowedUserTypes: [1,2,3]
    },
    beforeEnter: requireRole( [1,2,3] )
  },
  {
    path: "/email-tags",
    name: "EmailTags",
    component: EmailTags,
    meta: { jwtRequiresAuth: true },
    meta: {
      jwtRequiresAuth: true,
      allowedUserTypes: [1,2]
    },
    beforeEnter: requireRole( [1,2] )
  },
  {
    name: "WorkFlowsIt",
    path: "/workflows-it",
    component: WorkFlowsIt,
    meta: { jwtRequiresAuth: true },
  },
  {
    name: "GenralSettingsApproval",
    path: "/approval-type",
    component: GenralSettingsApproval,
    meta: {
      jwtRequiresAuth: true,
      allowedUserTypes: [1,2]
    },
    beforeEnter: requireRole( [1,2] )
  },
  {
    name: "CustomFields",
    path: "/custom-fields",
    component: CustomFields,
    meta: { jwtRequiresAuth: true },
  },
  {
    name: "Styling",
    path: "/styling",
    component: Styling,
    meta: { jwtRequiresAuth: true },
  },
  {
    name: "AccessControl",
    path: "/access-control",
    component: AccessControl,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/emplyee-user-form/:taskId/:readOnly",
    name: "EmployeeUserFormPage",
    props: true,
    component: EmployeeUserFormPage,
    meta: {
      jwtRequiresAuth: true,
      allowedUserTypes: [1,2,3]
    },
    beforeEnter: requireRole( [1,2,3] )
  },
  {
    path: "/emplyee-user-approval/:readOnly",
    name: "EmployeeUserApprovalPage",
    props: true,
    component: EmployeeUserApprovalPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/emplyee-user-exam/:taskId/:readOnly",
    name: "EmployeeUserExamPage",
    props: true,
    component: EmployeeUserExamPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/emplyee-training/:taskId/:readOnly",
    name: "EmployeeUserTrainingPage",
    props: true,
    component: EmployeeUserTrainingPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-pdf-training/:taskId/:readOnly",
    name: "EmployeeUserTrainingPDF",
    props: true,
    component: EmployeeUserTrainingPDF,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/emplyee-training-exam/:taskId/:readOnly",
    name: "EmployeeUserTrainingWithPracticeExamPage",
    props: true,
    component: EmployeeUserTrainingWithPracticeExamPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/add-complaint",
    name: "EmployeeComplaintFormPage",
    props: true,
    component: EmployeeComplaintFormPage,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/update-profile",
    name: "UpdateEmployeeProfile",
    component: UpdateEmployeeProfile,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-tasks/:taskType",
    name: "employeeTasks",
    component: employeeTasks,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-policies",
    name: "employeePolicies",
    component: employeePolicies,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-trainings",
    name: "employeeTrainings",
    component: employeeTrainings,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-certifications",
    name: "employeeCertifications",
    component: employeeCertifications,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-approvals",
    name: "employeeApprovals",
    component: employeeApprovals,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-approvals-user-form",
    name: "userform",
    component: EmployeeApprovalsForm,
    meta: { jwtRequiresAuth: true },
  },
  {
    path: "/employee-complaints",
    name: "employeeComplaints",
    component: employeeComplaints,
    meta: { jwtRequiresAuth: true },
  },
];
